import cs from './cs.json'
const trans = cs
export default trans
